import { render } from "./8.vue?vue&type=template&id=1335dc5c"
import script from "./8.vue?vue&type=script&lang=js"
export * from "./8.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__